import { createSelector } from 'reselect'
import answerStatus from 'helpers/enums/answerStatus'

const activitiesSelector = state => state.game.activities.filter(activity => activity.state !== 'deleting')

const pendingactivitiesSelector = createSelector(
	[activitiesSelector],
	activities => activities.reduce((accumulator, activity) => {
		if (activity.state !== 'ready') {
			accumulator.push(activity)
		} else {
			const incompleteAnswerIndex = activity.answers.findIndex(answer => answer.status !== answerStatus.READY)
			if (incompleteAnswerIndex !== -1) {
				accumulator.push(activity)
			}
		}
		return accumulator
	}, [])
)

export default createSelector(
	[ pendingactivitiesSelector],
	pendingActivities => pendingActivities.length > 0
)
